<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card flat class="dt-border pad-10">
      <v-btn icon absolute top right @click="$emit('closeModal')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <br />
      <v-card-title class="d-flex justify-center">
        <h3 class="text-center text-capitalize">
          {{ detail.title }} Notification
        </h3>
      </v-card-title>
      <v-card-text class="mt-8">
        <v-row class="text-center" justify="center" align="center">
          <v-col>
            <div class="card rounded pa-5 dt-border">
              <v-icon size="30" color="primary"> mdi-calendar </v-icon>
              <p class="mt-5 mb-0" style="font-size: 16px">
                {{ formatDate(detail.publicationDate) }}
              </p>
            </div>
          </v-col>
          <v-col>
            <div class="card rounded pa-5 dt-border">
              <v-icon size="30" color="primary"> mdi-clock-outline </v-icon>
              <p class="mt-5 mb-0" style="font-size: 16px">
                {{ formatTime(detail.publicationDate) }}
              </p>
            </div>
          </v-col>
        </v-row>
        <div class="mt-10">
          <h2 class="black--text">Description</h2>
          <p v-if="detail.details != '' " style="font-size:17px">{{ detail.details }}</p>
          <p v-if="detail.details == '' " style="font-size:16px">*No record*</p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { parseTimestamp, dateFormatter } from "@/utils/dates";
export default {
  props: {
    detail: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate(date) {
      return dateFormatter(date);
    },
    formatTime(time) {
      return parseTimestamp(new Date(time), "HH:mm");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>